// eslint-disable-next-line import/no-anonymous-default-export, import/no-default-export
export default '5.0.0/2024-10-21T19:07';
